export const ASSISE_PARTENAIRE_COMMERCIAUX_UPDATE_SET_UPDATED =
  "ASSISE_PARTENAIRE_COMMERCIAUX_UPDATE_SET_UPDATED";
export const ASSISE_PARTENAIRE_COMMERCIAUX_UPDATE_TOGGLE_LOADING =
  "ASSISE_PARTENAIRE_COMMERCIAUX_UPDATE_TOGGLE_LOADING";
